import { render, staticRenderFns } from "./TemplateTerminal.vue?vue&type=template&id=378d423b&scoped=true"
import script from "./TemplateTerminal.vue?vue&type=script&lang=js"
export * from "./TemplateTerminal.vue?vue&type=script&lang=js"
import style0 from "./TemplateTerminal.vue?vue&type=style&index=0&id=378d423b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d423b",
  null
  
)

export default component.exports